import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-upload-task-modal',
  templateUrl: './upload-task-modal.component.html',
  styleUrls: ['./upload-task-modal.component.scss'],
})
export class UploadTaskModalComponent implements OnInit {
  @Input() imageTypeId: number;
  @Output() dismiss = new EventEmitter();

  responseText = '';

  constructor(private auth: AuthService, private api: ApiService) {}

  ngOnInit(): void {
    if (this.auth.driverID) {
      this.api.createUploadTask(this.imageTypeId, this.auth.driverID).subscribe(
        (res) => {
          this.responseText = res;
        },
        (err) => {
          console.log(err);
          this.responseText =
            'Failed to create upload task. Please try again later.';
        }
      );
    }
  }

  closeModal() {
    if (!this.responseText) {
      return;
    }

    this.dismiss.emit();
  }
}
